import React from 'react';
import './style.scss';
import cardImg from '../../../../assets/images/cardImg.jpg';
import cardimg1 from '../../../../assets/images/cardigm1.jpg';
import cardImg4 from '../../../../assets/images/cardImg4.png';
import cardImg3 from '../../../../assets/images/cardImg3.jpg';

const CardsSection = () => {

    const cardData = [
        {
            title: "Comprehensive Assessment",
            textList: [
                "Location is evaluated in 8 categories, with over 150 fields of criteria covering the full range of client procurement needs.",
                "With an emphasis on factual questions, FlexGrade can ensure the assessment is grounded in quantitative data rather than qualitative feedback.",
                "Supporting documents must be submitted in accordance with the relevant criteria, with FlexGrade Market Reviews completed to ensure compliance and cross-reference data accuracy. "
            ],
            image: cardimg1,
            imagePosition: "right"
        },
        {
            title: "Structured Scoring System",
            textList: [
                "FlexGrade evaluates workspace quality through self-reported criteria and weighted metrics, calculating scores centered on the factors that shape a productive workday. ",
                "Assessments are updated annually to align with evolving client demands and market trends, with locations evaluated on a yearly basis.",
            ],
            image: cardImg,
            imagePosition: "left"
        },
        {
            title: "Quality Awards",
            textList: [
                "Bronze, Silver, and Gold badges are awarded to operators who demonstrate commitments in high quality offerings. ",
                "Qualification for award badges is based on both meeting specific score thresholds and satisfying minimum requirements.",
                "Badges are awarded for overall location quality, as well as excellence in any of the 8 assessment categories.",
                "",
            ],
            image: cardImg3,
            imagePosition: "right"
        },
        {
            title: "Dashboard and Analytic Intelligence",
            textList: [
                "Flexgrade dashboard empowers operators with benchmarking insights to measure performance against market standards.",
                "Providing a tailored plan for each location, guides operators on tangible actions for areas of improvements.",
                "Operators can submit a re-assessment post upgrades and enhancement for an opportunity to upgrade their award badge. ",
            ],
            image: cardImg4,
            imagePosition: "left"
        },
    ]

    return (
        <div className='cards__section__main custom__container'>
            {cardData?.map((v, i) => {
                return <div className={`card__data ${v?.imagePosition}`}>
                    <div className='card__content__section'>
                        <h3>
                            {v?.title}
                        </h3>
                        <div className='heading__border' />
                        <div className='text__list__container'>
                            {v?.textList?.map((v, i) => {
                                return <>
                                    <p key={i}>
                                        {v}
                                    </p>
                                    <br />
                                </>
                            })}
                        </div>
                    </div>
                    <div className='card__content__section'>
                        <img src={v?.image} alt='card_image' />
                    </div>
                </div>
            })}
        </div>
    )
}

export default CardsSection;